/**
 * Escapes special characters in a string so that it can be used safely in a regular expression.
 */
export function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Cleans a JSON response string by removing only the markdown code fences.
 * This will remove an opening line like "```json" (or "```") and a trailing "```"
 * without touching the actual JSON content.
 */
export function cleanJSONResponse(text) {
    if (!text) return "";
    let cleaned = text;
    // Remove the opening triple backticks and optional "json" (case-insensitive)
    cleaned = cleaned.replace(/^```(?:json)?\s*/i, "");
    // Remove the closing triple backticks
    cleaned = cleaned.replace(/\s*```$/, "");
    return cleaned.trim();
}

/**
 * Cleans a sentence text for display by removing stray formatting characters.
 * This function ensures that there are no asterisks, no parentheses, nor any text inside parentheses.
 */
export function cleanSentenceText(text) {
    if (!text) return "";
    let cleaned = text;
    // Remove stray backticks
    cleaned = cleaned.replace(/`/g, "");
    // Remove asterisks
    cleaned = cleaned.replace(/\*/g, "");
    // Remove parentheses and any text contained within them
    cleaned = cleaned.replace(/\([^)]*\)/g, "");
    return cleaned.trim();
}

/**
 * Cleans the story output object to ensure that none of the text values
 * (title, titleTranslation, each sentence in story and translation) contain
 * any asterisks or extra symbols. This function leverages cleanSentenceText.
 */
export function cleanStoryOutput(storyObject) {
    if (storyObject.title) {
        storyObject.title = cleanSentenceText(storyObject.title);
    }
    if (storyObject.titleTranslation) {
        storyObject.titleTranslation = cleanSentenceText(storyObject.titleTranslation);
    }
    if (Array.isArray(storyObject.story)) {
        storyObject.story = storyObject.story.map(sentence => cleanSentenceText(sentence));
    }
    if (Array.isArray(storyObject.translation)) {
        storyObject.translation = storyObject.translation.map(sentence => cleanSentenceText(sentence));
    }
    return storyObject;
}
